import insertionQ from 'insertion-query'

function initialise(el) {
  const items = $('.SubNav-items', el)
  el.addEventListener('mouseenter', () => {
    if (items.not('.is-open').length) {
      const bodyClick = e => {
        if (items.has(e.target).length) return

        $('body').off('click', bodyClick)
        items.removeClass('is-open')
      }
      setTimeout(() => {
        $('body').on('click', bodyClick)
      })
      items.addClass('is-open')
    }
  })

  el.addEventListener('mouseleave', () => {
    if (items.hasClass('is-open')) {
      items.removeClass('is-open')
    }
  })
}

export default class SubNavController {
  constructor() {
    $('.SubNav').each((index, el) => initialise(el))

    // handle new instances being added at runtime
    insertionQ('.SubNavList').every(el => initialise(el))
  }
}
